'use client'

import { createContext, useContext, type ReactNode } from 'react'

import { usePrivacyModeStore } from '~/store/privacyModeStore'

const PrivacyModeExemptContext = createContext(false)

/**
 * Wraps page content that privacy mode leaves visible. Settings and admin
 * pages are deliberate flows, like forms, and their rows exist to be read.
 * The sidebar sits outside these layouts, so it stays masked.
 */
export const PrivacyModeExempt = ({ children }: { children: ReactNode }) => (
  <PrivacyModeExemptContext.Provider value={true}>
    {children}
  </PrivacyModeExemptContext.Provider>
)

/** Whether the calling component should mask its amounts and addresses. */
export const usePrivacyMode = () => {
  const isPrivacyModeOn = usePrivacyModeStore((state) => state.isPrivacyModeOn)
  const isExempt = useContext(PrivacyModeExemptContext)
  return isPrivacyModeOn && !isExempt
}
